export default new (class Cheat {
  constructor(func) {}

  setValues(jsondata) {
    window.force_grids = jsondata.force_grids;
  }
  setCheat(value) {
    fetch("./data/" + value + ".json")
      .then((response) => {
        console.log("ssss");
        return response.json();
      })
      .then((jsondata) => this.setValues(jsondata))
      .catch((error) => console.log(error));
  }
})();
